module.exports = __webpack_public_path__ + "static/media/feedback-active.930c202a.svg";